import type { ComponentProps } from 'react'
import { PrintStandardVoucher } from 'components/Pages/ExperienceVoucher/PrintStandardVoucher'

type Props = ComponentProps<typeof PrintStandardVoucher>

export function PrintIngressoVoucher({ voucher, ...props }: Props) {
  const customerName = [voucher.customer?.name, voucher.customer?.surname]
    .map(value => value?.trim())
    .filter(Boolean)
    .join(' ')

  return <PrintStandardVoucher voucher={voucher} customerName={customerName || undefined} {...props} />
}
